import { render, staticRenderFns } from "./speak-xunfei.vue?vue&type=template&id=24b0b9d9"
import script from "./speak-xunfei.vue?vue&type=script&lang=js"
export * from "./speak-xunfei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports